module.exports = __webpack_public_path__ + "b744957566fe077005ef34e3784aaaa5.jpg";